import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import styles from './pager-widget.scss';

class PagerWidget extends Component {
    static propTypes = {
        goToNext: PropTypes.func.isRequired,
        goToPrevious: PropTypes.func.isRequired,
        pageCount: PropTypes.number.isRequired,
        handlePageChanged: PropTypes.func.isRequired,
        currentPage: PropTypes.number,
        handleClick: PropTypes.func
    };

    static defaultProps = {
        currentPage: 0,
        handleClick: () => {}
    };

    constructor(props) {
        super(props);
        this.containerRef = React.createRef();
    }

    componentDidMount() {
        this.updateTabIndexes();
    }

    componentDidUpdate() {
        this.updateTabIndexes();
    }

    updateTabIndexes() {
        if (!this.containerRef.current) return;
        const container = this.containerRef.current;
        // Make all page links focusable first (react-paginate renders <a> without href)
        container.querySelectorAll('.pager-widget li a').forEach((link) => {
            link.setAttribute('tabindex', '0');
        });
        // Then remove focus from active (current page) and disabled (e.g. prev on first page) links
        container
            .querySelectorAll('.pager-widget li.active a, .pager-widget li.disabled a')
            .forEach((link) => {
                link.setAttribute('tabindex', '-1');
            });
    }

    render() {
        const { goToPrevious, goToNext, pageCount, currentPage, handlePageChanged, handleClick } =
            this.props;

        const previousLabel = (
            <React.Fragment>
                <span className="hidden-a11y">previous page</span>
                <i
                    className="fas fa-angle-left"
                    aria-hidden="true"
                    onClick={(e) => {
                        goToPrevious(e);
                    }}
                />
            </React.Fragment>
        );

        const nextLabel = (
            <React.Fragment>
                <span className="hidden-a11y">next page</span>
                <i
                    className="fas fa-angle-right"
                    aria-hidden="true"
                    onClick={(e) => {
                        goToNext(e);
                    }}
                />
            </React.Fragment>
        );

        return (
            <div ref={this.containerRef} onClick={handleClick}>
                <ReactPaginate
                    containerClassName={`pager-widget ${styles.pager}`}
                    subContainerClassName="pages pagination"
                    previousLabel={previousLabel}
                    nextLabel={nextLabel}
                    pageCount={pageCount}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    initialSelected={currentPage}
                    forcePage={currentPage}
                    breakLabel="..."
                    breakClassName="break-me"
                    onPageChange={handlePageChanged}
                    activeClassName="active"
                />
            </div>
        );
    }
}

export default PagerWidget;
